import styled from 'styled-components/native'
import styledReact from 'styled-components'
import { Constants } from '@sukiai/components'
import { whiteSmoke } from '@sukiai/components/lib/colors'
import playButton from '../../lib/assets/icons/play-button.svg'
import helpQuestionMark from '../../lib/assets/icons/help-question-mark.svg'
import helpChat from '../../lib/assets/icons/help-chat.svg'

const { ICON_SIZE } = Constants

export const Container = styled.View`
  width: 100%;
`

export const StatusContainer = styled.View`
  height: 60px;
  width: 100%;
  padding: 0 30px;
`

export const StatusIcon = styled.View`
  background: ${props => props.color};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  top: 2px;
`

export const ContentText = styled.Text`
  font-size: 18px;
  color: ${props => props.color};
  right: 60px;
  padding: 0 5px;
`

export const ActionContainer = styled.View`
  height: 130px;
  padding: 35px 30px;
  cursor: ${props => props.ishovered === 'true'
    ? 'pointer'
    : 'auto'
};
  background-color: ${props => props.ishovered === 'true'
    ? '#F4F7FA'
    : '#FFFFFF'
};
`
export const ContentHolder = styled.View`
  height: 60px;
`

export const Title = styled.Text`
  font-size: 22px;
  font-weight: 500;
  height: 36px;
  padding: 5px 0;
  letter-spacing: -0.3px;
`

export const Desc = styled.Text`
  font-size: 18px;
  width: 85%;
`

export const StyledText = styled.Text`
  height: 24px;
`
export const StyledAdditionalText = styled.Text`
  white-space: nowrap;
`

export const IconContainer = styled.View`
  position: absolute;
  right: 0;
  top: 0;
`

export const PlayButtonIcon = styledReact.img.attrs({
  src: playButton,
  height: ICON_SIZE.LARGE,
  width: ICON_SIZE.LARGE
})`
`

export const HelpIcon = styledReact.img.attrs({
  src: helpQuestionMark,
  height: ICON_SIZE.LARGE,
  width: ICON_SIZE.LARGE
})`
`

export const HelpChatIcon = styledReact.img.attrs({
  src: helpChat,
  height: ICON_SIZE.LARGE,
  width: ICON_SIZE.LARGE
})`
`

export const CloseButton = styled.Text`
  border: 1px solid ${whiteSmoke};
  border-radius: 2px;
  padding: 0 10px;
  text-align: center;
  line-height: 35px;
  color: ${whiteSmoke};
  font-size: 10pt;
  position: absolute;
  top: 0;
  right: -115px;
  cursor: ${props => props.isclosebuttonhovered === 'true'
    ? 'pointer'
    : 'auto'
};
`

export const PlayerContainer = styled.Text`
  position: absolute;
  width: 75%;
  top: 2%;
  left: 12.5%;
  height: 40%;
  z-index: 1;
  display: ${props => props.shouldvideoplayershowandplay === 'true'
    ? 'block'
    : 'none'
};
`
